import { render, staticRenderFns } from "./PreNewStudent.vue?vue&type=template&id=f8437408&scoped=true&"
import script from "./PreNewStudent.vue?vue&type=script&lang=js&"
export * from "./PreNewStudent.vue?vue&type=script&lang=js&"
import style0 from "./PreNewStudent.vue?vue&type=style&index=0&id=f8437408&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8437408",
  null
  
)

export default component.exports